import { InputNumberProps } from 'antd'
import { MeteDataRes } from 'packages/sdks-next/growp'

export interface OtherConfig {
  disabled?: boolean
  placeholder?: string & [string, string]
  options?: {
    label: string
    value: string
  }[]
  metadata?: MeteDataRes
  inputNumberProps?: Omit<InputNumberProps<number>, 'value' | 'onChange'>
}

export interface FormItemConfig {
  type: ISearchFormItemType
  label: string
  name: string
  valuePropName?: string
  otherConfig?: OtherConfig
}

export type FormConfig = { [key: string]: FormItemConfig[] }

export interface IMap {
  [key: string]: string
}

export interface ISearchParams {
  [key: string]: any
}

export interface IPageInfo {
  page: number
  perPage: number
}

export type TableQuery = {
  [key: string]: string | number | undefined
}

export interface IParams {
  [key: string]: any
}

export enum ISearchFormItemType {
  Input = 'input',
  Select = 'select',
  Multi = 'multi',
  DateRange = 'dateRange',
  TextArea = 'textArea',
  TimeRange = 'timeRange',
  NumRange = 'numRange',
  Null = 'null',
  Date = 'date',
  Number = 'number',
}

export interface NumberRangeValue {
  egt?: number | null
  elt?: number | null
}
